import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { listSolicitudesClase, confirmarSolicitudClase, rechazarSolicitudClase, cancelarSolicitudClasePagada } from '../../lib/adminApi';
import { st } from '../../lib/solicitudesTxt';

function Fila({ s, T, lang, onDone }) {
  const [abierto, setAbierto] = useState(false);
  const [imp, setImp] = useState(s.importe_euros != null ? String(s.importe_euros) : '');
  const [fecha, setFecha] = useState(String(s.fecha_confirmada || s.fecha_deseada).slice(0, 10));
  const [hora, setHora] = useState(s.hora_confirmada || s.hora_deseada);
  const [nota, setNota] = useState(s.nota_anya || '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  async function confirmar() {
    setBusy(true); setMsg(null);
    try { await confirmarSolicitudClase(s.id, { importe_euros: Number(imp), fecha_confirmada: fecha, hora_confirmada: hora, nota }); setAbierto(false); onDone(); }
    catch (e) { setMsg(e.message); } finally { setBusy(false); }
  }
  async function rechazar() {
    if (!window.confirm(T('a_confirm_rech'))) return;
    setBusy(true);
    try { await rechazarSolicitudClase(s.id, nota); onDone(); } catch (e) { setMsg(e.message); } finally { setBusy(false); }
  }
  async function cancelarPagada() {
    const imp = Number(s.importe_euros).toFixed(2);
    if (!window.confirm(T('a_confirm_c1').replace('{{imp}}', imp))) return;
    if (!window.confirm(T('a_confirm_c2').replace('{{imp}}', imp))) return;
    setBusy(true); setMsg(null);
    try { await cancelarSolicitudClasePagada(s.id); alert(T('a_ok_reemb').replace('{{imp}}', imp)); onDone(); }
    catch (e) { alert(e.message); } finally { setBusy(false); }
  }
  const abierta = s.estado === 'pendiente' || s.estado === 'confirmada';
  return (
    <tr>
      <td><strong>{s.nombre}</strong><br /><small>{s.email}{s.telefono ? ` · ${s.telefono}` : ''}</small></td>
      <td>
        {new Date(`${String(s.fecha_deseada).slice(0, 10)}T00:00:00`).toLocaleDateString(lang)} {s.hora_deseada} · {s.modalidad === 'online' ? T('online') : T('presencial')} · {s.num_personas}p
        {s.mensaje && <><br /><small>{s.mensaje}</small></>}
        {s.importe_euros != null && <><br /><small><b>{Number(s.importe_euros).toFixed(2)} €</b> · {String(s.fecha_confirmada).slice(0, 10)} {s.hora_confirmada}</small></>}
      </td>
      <td>{T('e_' + s.estado)}</td>
      <td>
        {s.estado === 'pagada' && (
          <button type="button" className="btn-mini" onClick={cancelarPagada} disabled={busy}>{T('a_cancelar_pagada')}</button>
        )}
        {abierta && !abierto && (
          <>
            <button type="button" className="btn-mini btn-primary" onClick={() => setAbierto(true)}>{s.estado === 'confirmada' ? T('a_reenviar') : T('a_confirmar')}</button>{' '}
            <button type="button" className="btn-mini" onClick={rechazar} disabled={busy}>{T('a_rechazar')}</button>
          </>
        )}
        {abierta && abierto && (
          <div style={{ display: 'grid', gap: 6, minWidth: 220 }}>
            <label>{T('a_importe')}<input type="number" min="1" step="0.5" value={imp} onChange={(e) => setImp(e.target.value)} /></label>
            <label>{T('a_fecha')}<input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} /></label>
            <label>{T('a_hora')}<input type="time" value={hora} onChange={(e) => setHora(e.target.value)} /></label>
            <label>{T('a_nota')}<textarea rows={2} value={nota} onChange={(e) => setNota(e.target.value)} maxLength={500} /></label>
            {msg && <small className="modal-error-general">{msg}</small>}
            <span>
              <button type="button" className="btn-mini btn-primary" onClick={confirmar} disabled={busy || !(Number(imp) > 0)}>{T('a_enviar')}</button>{' '}
              <button type="button" className="btn-mini" onClick={() => setAbierto(false)}>{T('a_cancelar')}</button>
            </span>
          </div>
        )}
      </td>
    </tr>
  );
}

export default function AdminSolicitudes() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || 'es').toLowerCase();
  const T = (k) => st(lang, k);
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  const cargar = useCallback(() => { listSolicitudesClase().then((r) => setRows(r.data || [])).catch((e) => setError(e.message)); }, []);
  useEffect(() => { cargar(); }, [cargar]);
  return (
    <div className="admin-page">
      <div className="admin-page-header"><h1>{T('a_titulo')}</h1></div>
      {error && <p className="modal-error-general">{error}</p>}
      {rows && rows.length === 0 && <p>{T('a_vacio')}</p>}
      {rows && rows.length > 0 && (
        <div className="admin-tabla-wrap">
          <table className="admin-tabla">
            <thead><tr><th>{T('a_cliente')}</th><th>{T('a_pedido')}</th><th>{T('a_estado')}</th><th>{T('a_acciones')}</th></tr></thead>
            <tbody>{rows.map((s) => <Fila key={s.id} s={s} T={T} lang={lang} onDone={cargar} />)}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
